<template>
    <div>
        <div class="row box">
            <div class="col-lg-8">
                <h4><i class="fas fa-cart-arrow-down"></i> مراجعة المشتريات</h4>
                <div class="responsive-table">
                    <table v-if="basket.length">
                        <tr>
                            <th>المنتج</th>
                            <th>السعر</th>
                            <th>الكمية</th>
                            <th>المجموع</th>
                            <th></th>
                        </tr>
                        <tr
                            v-for="(product, index) in products"
                            :key="product.id"
                        >
                            <td>
                                <input
                                    type="hidden"
                                    name="product_ids[]"
                                    :value="product.id"
                                />
                                <img :src="product.photo" alt="" height="50" />
                                <br />
                                <p>{{ product.title }}</p>
                            </td>
                            <td>
                                <div class="price">
                                    <span
                                        v-if="
                                            product.PriceFormat !==
                                                product.netPriceFormat
                                        "
                                        class="old"
                                        >{{ product.PriceFormat }}</span
                                    >
                                    {{ product.netPriceFormat }}
                                </div>
                            </td>
                            <td>
                                <div
                                    class="input-group update-quantity input-group-sm"
                                >
                                    <input
                                        type="hidden"
                                        name="quantities[]"
                                        :value="product.quantity"
                                    />
                                    <div class="input-group-prepend">
                                        <button
                                            @click.prevent="
                                                changeQuantity(product, 1)
                                            "
                                            type="button"
                                            class="btn btn-secondary"
                                        >
                                            +
                                        </button>
                                    </div>
                                    <input
                                        type="number"
                                        class="form-control quantity"
                                        v-model="product.quantity"
                                        min="1"
                                        readonly
                                    />
                                    <div class="input-group-append">
                                        <button
                                            @click.prevent="
                                                changeQuantity(product, -1)
                                            "
                                            type="button"
                                            class="btn btn-secondary"
                                        >
                                            -
                                        </button>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div class="price">
                                    {{ product.netPrice * product.quantity }}
                                    ر.س
                                </div>
                            </td>
                            <td>
                                <a
                                    href="#"
                                    class="text-primary"
                                    @click.prevent="
                                        removeProduct(index, product)
                                    "
                                >
                                    <i class="far fa-trash-alt"></i>
                                </a>
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
            <div class="col-lg-4">
                <section class="invoice" v-if="basket.length">
                    <div class="wrapper">
                        <dl>
                            <dt>مبلغ الطلب</dt>
                            <dd>{{ total_price_net }} ر.س</dd>
                            <template v-if="applied_coupon">
                                <dt>الخصم</dt>
                                <dd>{{ applied_coupon.discount }} %</dd>
                            </template>
                            <dt>تكلفة الشحن</dt>
                            <dd>{{ shipping_cost }} ر.س</dd>
                            <dt>رسوم طريقة الدفع</dt>
                            <dd>{{ payment_method_amount }} ر.س</dd>
                        </dl>
                        <hr />
                        <dl>
                            <dt>إجمالي الطلب</dt>
                            <dd>{{ total_price }} ر.س</dd>
                        </dl>
                    </div>
                </section>

                <section class="coupon my-2" v-if="basket.length">
                    <input
                        type="text"
                        placeholder="لديك كوبون تخفيض ؟"
                        v-model="coupon"
                        @keypress.enter.prevent="applyCoupon"
                        name="coupon_code"
                    />
                    <button
                        @click.prevent="applyCoupon()"
                        type="button"
                        class="btn btn-primary"
                    >
                        تطبيق
                    </button>
                </section>
            </div>
            <div class=""></div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Checkout",
    props: {
        basket: {
            type: Array,
            required: true
        },
        coupons: {
            type: Array,
            required: true
        },
        store: {
            type: Object
        }
    },

    data() {
        return {
            products: this.basket,
            coupon: null,
            applied_coupon: null,

            payment_method_amount: 0
        };
    },

    mounted() {
        Livewire.on("paymentMethodUpdate", paymentMethod => {
            this.payment_method_amount = paymentMethod.amount;
        });
    },

    computed: {
        total_price_net() {
            return this.products.reduce(
                (previousValue, product) =>
                    previousValue + product.netPrice * product.quantity,
                0
            );
        },
        shipping_cost() {
            // Check prodcuts.freeShipping = true
            if (this.products.find(product => product.freeShipping)) {
                return 0;
            }

            if (this.total_price_net >= this.store.min_total_of_free_shipping) {
                return 0;
            }

            return this.store.shipping_cost;
        },
        total_price() {
            let coupon_price = 0;

            if (this.applied_coupon) {
                coupon_price = this.applied_coupon.discount;
            }

            return (
                this.total_price_net -
                (this.total_price_net * coupon_price) / 100 +
                this.shipping_cost +
                this.payment_method_amount
            );
        }
    },

    methods: {
        applyCoupon() {
            let coupon = this.coupons.find(
                coupon => coupon.code === this.coupon
            );
            if (!coupon) {
                alert("الكوبون غير صحيح");
                return;
            }
            this.applied_coupon = coupon;
        },
        changeQuantity(product, quantity) {
            if (product.quantity == 1 && quantity == -1) {
                return;
            }

            if (
                product.quantity == product.max_quantity_per_order &&
                quantity == 1
            ) {
                return;
            }

            product.quantity += quantity;
        },
        removeProduct(index, product) {
            Livewire.dispatch("removeProduct", {product_id: product.id});

            this.products.splice(index, 1);
        }
    }
};
</script>
